module.exports = __webpack_public_path__ + "img/businessman.bde7d0da.svg";